import {useParams} from 'react-router-dom';

import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';
import UserTable from '@/screens/User/List/UserTable';
import type {AdminAfriexPerson} from '@/types';

import useTierUserList from './useTierUserList';

const TierUserList = () => {
  const params = useParams();
  const tierId = params?.tierId || '';
  const {isLoading, fetchList, total, list} = useTierUserList(tierId);

  return (
    <main className="mx-10">
      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <UserTable items={list as AdminAfriexPerson[]} />
        )}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};

export default TierUserList;
